import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MtnImg from "../assets/mtn.png"
import AirtelImg from "../assets/at.jpg"
import TelecelImg from "../assets/telecel.jpg"
import Modal from '../components/Modal';
import DataOrderForm from '../components/DataOrderForm';
import AlertModal from '../components/AlertModal';
import { getGlobalAlert } from '../services/firebaseService';

export default function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState('');
  const [isCheckingAlert, setIsCheckingAlert] = useState(true);
  const [alert, setAlert] = useState(null);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const checkAlert = async () => {
      try {
        const alertData = await getGlobalAlert();
        if (alertData) {
          setAlert(alertData);
          setShowAlert(true);
        }
      } catch (error) {
        console.error('Error checking alert:', error);
      } finally {
        setIsCheckingAlert(false);
      }
    };

    checkAlert();
  }, []);

  const handleBuyData = async (network) => {
    setSelectedNetwork(network);

    // Check for alerts again before opening order form
    try {
      const alertData = await getGlobalAlert();
      if (alertData) {
        // If there's an alert, show it first
        setAlert(alertData);
        setShowAlert(true);
      } else {
        // No alert, open order form directly
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Error checking alert:', error);
      // If error checking alert, proceed to order form anyway
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
    // After closing alert, open the order form if a network was selected
    if (selectedNetwork) {
      setIsModalOpen(true);
    }
  };

  // Show loading screen while checking for alerts
  if (isCheckingAlert) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex items-center justify-center">
        <div className="text-center">
          {/* Animated logo/brand */}
          <div className="mb-8 animate-pulse">
            <div className="inline-flex items-center space-x-2">
              <span className="text-5xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                ★
              </span>
              <span className="text-3xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                Top Data
              </span>
            </div>
          </div>

          {/* Animated spinner */}
          <div className="relative inline-flex items-center justify-center">
            {/* Outer spinning ring */}
            <div className="absolute animate-spin rounded-full h-16 w-16 border-4 border-transparent border-t-blue-600 border-r-purple-600"></div>
            {/* Inner pulsing circle */}
            <div className="animate-pulse rounded-full h-12 w-12 bg-gradient-to-br from-blue-400 to-purple-400 opacity-20"></div>
          </div>

          {/* Loading text */}
          <p className="mt-6 text-gray-600 font-medium animate-pulse">Checking for updates...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f8f6f4]">
      {/* Header */}
      <header className="flex justify-between items-center px-6 py-4 bg-[#f8f6f4] border-b border-gray-200">
        <div className="text-xl font-bold tracking-wide">
          <span className="text-black">★</span> Top Data
        </div>
        <Link
          to="/contact"
          className="text-sm text-gray-600 hover:text-black transition font-medium"
        >
          Contact Us
        </Link>
      </header>

      {/* Main Section */}
      <main className="grid grid-cols-1 md:grid-cols-3 min-h-[calc(100vh-45px)]">
        {/* Spend & Save */}
        <div
          className="relative flex flex-col justify-center items-center text-white cursor-pointer overflow-hidden group"
          style={{ border: 'solid 2px #000', background: '#fff' }}
        >
          <div className="relative text-center flex flex-col items-center px-6">
            <img src={MtnImg} className=' mb-12'/>
            <h1 className="text-4xl md:text-5xl text-black font-bold mb-4 viga-regular">MTN Data</h1>
            <p className="text-[1.3rem] mb-6 text-black  zen-regular">
            Low cost & affordable data.
            </p>
            <button
              onClick={() => handleBuyData('mtn')}
              className="w-[10rem] hover:bg-[#ffcb03] mb-12 hover:text-white bg-black text-white px-6 py-3 rounded-md font-medium transition"
            >
              Buy Data
            </button>
          </div>
        </div>

        {/* Right Side: Two stacked boxes */}
        {/* <div className="flex flex-col h-full"> */}
          {/* Christmas Foodhall */}
          <div
            className="relative flex-1 flex flex-col justify-center items-center text-white cursor-pointer overflow-hidden group"
            style={{ border: 'solid 2px #000', background: '#fff' }}
          >
            <div className="relative text-center flex flex-col items-center px-6">
              <img src={AirtelImg} className=' mb-12'/>
              <h1 className="text-4xl md:text-5xl font-bold text-black mb-4 viga-regular">AirtelTigo Data</h1>
              <p className="text-[1.3rem] mb-6 text-black zen-regular">
              Low cost & affordable data.
              </p>
              <button
                onClick={() => handleBuyData('airteltigo')}
                className="w-[10rem] hover:bg-[#e32527] mb-12 hover:text-white bg-black text-white px-6 py-3 rounded-md font-medium transition"
              >
                Buy Data
              </button>
            </div>
          </div>

          {/* Island Experience */}
          <div
            className="relative flex-1 flex flex-col justify-center items-center text-white cursor-pointer overflow-hidden group"
            style={{ border: 'solid 2px #000', background: '#fff' }}
          >
            <div className="relative text-center flex flex-col items-center px-6">
              <img src={TelecelImg} className=' mb-12'/>
              <h1 className="text-4xl md:text-5xl font-bold text-black mb-4 viga-regular">Telecel Data</h1>
              <p className="text-[1.3rem] mb-6 text-black zen-regular">
              Low cost & affordable data.
              </p>
              <button
                onClick={() => handleBuyData('telecel')}
                className="w-[10rem] hover:bg-[#e32527] mb-12 hover:text-white bg-black text-white px-6 py-3 rounded-md font-medium transition"
              >
                Buy Data
              </button>
            </div>
          </div>
        {/* </div> */}
      </main>

      {/* Modal for Data Order Form */}
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <DataOrderForm network={selectedNetwork} />
      </Modal>

      {/* Global Alert Modal */}
      {alert && (
        <AlertModal
          isOpen={showAlert}
          onClose={handleCloseAlert}
          message={alert.message}
        />
      )}
    </div>
  );
}
